import {Injectable} from '@angular/core';
import {BackendFunctions, Sherpa} from "../../classes/Sherpa";
import {auth, sherpa, util} from "../../../services";
import {

} from "../../types/sherpa";
import {SherpaError} from "../../classes/SherpaError";

@Injectable({
	providedIn: 'root'
})
export class ConfigsService {

	private api: BackendFunctions = {};


	constructor() {
		sherpa.api$.subscribe((sherpa: Sherpa) => {
			this.api = sherpa.api;
		});
	}


	getLoggingAgreement(): Promise<boolean> {
		return this.api.getLoggingAgreement<boolean>(auth.token())
			.catch((e: SherpaError) => util.handleError(e));
	}

	setLoggingAgreement(value: boolean): Promise<void> {
		return this.api.setLoggingAgreement<void>(auth.token(), value)
			.catch((e: SherpaError) => util.handleError(e));
	}

	getUserPreferences(): Promise<any> {
		return this.api.getUserPreferences<any>(auth.token())
			.catch((e: SherpaError) => util.handleError(e));
	}

	setUserPreferences(config: any): Promise<any> {
		return this.api.setUserPreferences<any>(auth.token(), config)
			.catch((e: SherpaError) => util.handleError(e));
	}


	sleep(ms : number): Promise<any> {
		return this.api.sleep<any>(ms)
			.catch((e: SherpaError) => util.handleError(e));
	}
}
